import * as Localization from "expo-localization";
import AsyncStorage from "@react-native-async-storage/async-storage";
import getStack from "../constants/Stacks";
import Config from "../constants/Config";

const TRANSLATIONS_KEY = "cached_translations";
const TRANSLATIONS_VERSION_KEY = "cached_translations_version";
const TRANSLATIONS_LANGUAGES_KEY = "cached_translations_languages";
const LOCALE_KEY = "locale";
const stack = getStack();
function getDefaultTranslationsApiUrl() {
  if (stack?.graphql) {
    return stack.graphql.replace(/\/graphql\/?$/, "");
  }

  return stack?.web || "https://hrlm.bg";
}

const API_URL = process.env.EXPO_PUBLIC_TRANSLATIONS_API_URL || getDefaultTranslationsApiUrl();
const ENV_FALLBACK_LOCALE = process.env.EXPO_PUBLIC_FALLBACK_LOCALE || "en";

const defaultTranslations = {
  en: {
    "Поръчай тук": "Order here",
    "Кафе Верняно": "Vergnano Coffee",
    "Кафе Верняно - промо 10:00": "Vergnano Coffee - promo 10:00",
    Фреш: "Fresh juice",
    "Кафе Верняно - 100% Арабика": "Vergnano Coffee - 100% Arabica",
    "Кафе Верняно - Безкофеиново": "Vergnano Coffee - Decaf",
    Банкя: "Mineral water",
    "Кока-Кола": "Coca-Cola",
    Капи: "Cappy juice",
    Швепс: "Schweppes",
    Спрайт: "Sprite",
    "Студен чай": "Iced Tea",
    Чай: "Tea",
    Сода: "Soda",
    "3в1": "Nescafe 3in1",
    Лате: "Latte",
    Лимонада: "Lemonade",
    Фрапе: "Frappe",
    Нескафе: "Nescafé",
    "Капучино Верняно": "Cappuccino Vergnano",
    "Мляко с какао Верняно": "Vergnano Chocolate milk",
    "Топъл Шоколад Верняно": "Vergnano Hot Chocolate",
    "Външна батерия": "Powerbank",
    Цитронада: "Citronade",
    Самърсби: "Sommersby Cider",
    "Банкя - стъклена бутилка": "Mineral water - glass bottle",
    Корона: "Corona",
    "Jack Daniel's Honey Lemonade": "Jack Daniel's Honey Lemonade",
    "Bickens Pink & Pink Tonic Style": "Bickens Pink & Pink Tonic Style",
    "Bacardi Mojito": "Bacardi Mojito",
    Шот: "Shot",
    Шейкър: "Shaker",
    Фанта: "Fanta",
    Загорка: "Zagorka beer",
    "Хайникен наливна": "Heineken draft",
    Шприц: "Spriz",
    Аперол: "Aperol",
    Мартини: "Martini",
    Бианко: "Bianco",
    Кампари: "Campari",
    Бакарди: "Bacardi",
    Ликьор: "Liqueur",
    Дисароно: "Disaronno",
    Бушмилс: "Bushmills",
    Джони: "Johnnie",
    Джеймсън: "Jameson",
    "J&B": "J&B",
    "Джак Даниелс": "Jack Daniels",
    "Сингъл Барел": "Single Barrel",
    Житная: "Zytnia",
    Абсолют: "Absolut",
    "Руски Стандарт": "Russkii Standart",
    Финландия: "Finlandia",
    Бифитър: "Beefeater",
    Горданс: "Gordon's",
    "Горданс Пинк": "Gordon's Pink",
    Джин: "Gin",
    Бомбай: "Bombay",
    12: "12",
    7: "7",
    Пломари: "Plomari",
    Тсантали: "Tsantali",
    "Чивас Регал": "Chivas Regal",
    Кардю: "Cardhu",
    "Джентълмен Джак": "Gentleman Jack",
    Гленфидиш: "Glenfiddich",
    РедБул: "RedBull",
    "Сайкъл Сов Блан": "Cycle Sauvignon blanc",
    Столично: "Stolichno",
    Хайникен: "Heineken",
    Ариана: "Ariana",
    Старобърно: "Starobrno",
    Ботега: "Bottega",
    Морети: "Moretti",
    "Афтър Шок": "After Shock",
    Савой: "Savoy",
    "Зельоная Марка": "Green Mark",
    Столичная: "Stolichnaya",
    Търговище: "Targovishte",
    "Грей Гус": "Gray Goose",
    Белуга: "Beluga",
    "Бургас 63": "Burgas 63",
    "Бургаска Мускатова": "Burgas' Muscat grapes",
    "Кайлъшка гроздова": "Kaylashka",
    Карнобатска: "Karnobatska",
    Пещерска: "Peshterska",
    "Плиска Преслав": "Pliska Preslav",
    "Мента Пещера": "Peshtera Mint",
    "Къти Сарк": "Cutty Sark",
    "Джийм Бийм": "Jim Beam",
    "Джак Даниелс": "Jack",
    Грантс: "Grants",
    Метакса: "Metaxa",
    "Сайкъл Траминер": "Cycle Traminer",
    "Сайкъл Мерло и Пино Ноар": "Cycle Merlot & Pinot noir",
    "Сайкъл Розе": "Cycle Rose",
    "Едоардо Миролио Совиньон Блан": "Edoardo Miroglio Sauvignon Blanc",
    "JP Chenet - 250 мл": "JP. Chenet - 250 ml.",
    "Моет Шандон Брут": "Moët & Chandon Impérial Brut",
    Напитки: "Beverages",
    Коктейли: "Cocktails",
    "Друг алкохол": "Other alcohol",

    Кафетерия: "Coffee shop",
    Топли: "Hot",
    Фрешове: "Juices",
    късо: "Espresso",
    нормално: "Normal",
    дълго: "Long",
    лв: "BGN",
    "25 мл": "25 ml.",
    "300 мл": "300 ml.",
    "50 мл": "50 ml.",
    "200 мл": "200 ml.",
    "250 мл": "250 ml.",
    "330 мл": "330 ml.",
    "350 мл": "350 ml.",
    "355 мл": "355 ml.",
    "375 мл": "375 ml.",
    "250 мл": "250 ml.",
    "500 мл": "500 ml.",
    "750 мл": "750 ml.",
    Безалкохолни: "Beverages",
    Бири: "Beers",
    Водка: "Vodka",
    Уиски: "Whisky",
    "без захар": "diet",
    "с лимон": "with Lemon",
    портокал: "orange",
    праскова: "peach",
    кайсия: "apricot",
    ананас: "pineapple",
    мандарина: "tangerine",
    тоник: "tonic",
    лимон: "lemon",
    нар: "pomegranate",
    зелен: "green",
    "горски плодове": "berries",
    бяло: "white",
    черно: "black",
    "-": "-",
    ягода: "strawberry",
    "лайм-джинджър": "lime-ginger",
    мента: "mint",
    топло: "hot",
    студено: "cold",
    черен: "dark",
    бял: "white",
    "с кокос": "coconut",
    лате: "latte",
    "Micro USB": "Micro USB",
    "USB C": "USB C",
    iPhone: "iPhone",
    Боровинка: "blueberry",
    Ябълка: "apple",
    Круша: "pear",
    Манго: "mango",
    грейпфрут: "grapefruit",
    микс: "mix",
    малко: "single",
    червено: "red label",
    малка: "single",
    "12 годишно": "12 year old",
    боквайс: "bock weiss",
    вайс: "weiss",
    традиционна: "tradizionale",
    розе: "rose",

    "Additional comment:": "Notes:",
    "Table closed": "Table closed",
    "This table is already closed. Please ask staff to open a new table.": "This table is already closed. Please ask staff to open a new table.",
    "Failed to add item to table": "Failed to add item to table",

    // Landing page
    "Harlem": "Harlem",
    "Harlem by Refraction X": "Harlem by Refraction X",
    "Food, drinks, gaming": "Food, drinks, gaming",
    "Order from the bar, check the menu, or jump into the venue app.": "Order from the bar, check the menu, or jump into the venue app.",
    "Burger Nizza": "Burger Nizza",
    "Burgers, sides, delivery": "Burgers, sides, delivery",
    "Order online, check the menu, or choose pickup and delivery.": "Order online, check the menu, or choose pickup and delivery.",
    "Order, pickup, delivery": "Order, pickup, delivery",
    "Order online, check the menu, or continue into the venue app.": "Order online, check the menu, or continue into the venue app.",
    "Order now": "Order now",
    "Online orders": "Online orders",
    "Pickup or delivery": "Pickup or delivery",
    "Menu": "Menu",
    "Food and drinks": "Food and drinks",
    "E-sports": "E-sports",
    "PC stations": "PC stations",
    "VR": "VR",
    "Virtual reality": "Virtual reality",
    "Featured": "Featured",
    "Ready when you are": "Ready when you are",
    "Start order": "Start order",
    "Operator": "Operator",

    // Category and Product Management
    "Categories": "Categories",
    "Create New Category": "Create New Category",
    "Category ID (e.g., burgers)": "Category ID (e.g., burgers)",
    "Category Name": "Category Name",
    "Order": "Order",
    "Name": "Name",
    "Create Category": "Create Category",
    "Category created successfully": "Category created successfully",
    "Category updated successfully": "Category updated successfully",
    "Category deleted successfully": "Category deleted successfully",
    "Failed to create category": "Failed to create category",
    "Failed to update category": "Failed to update category",
    "Failed to delete category": "Failed to delete category",
    "Please enter both category ID and name": "Please enter both category ID and name",
    "Delete Category": "Delete Category",
    "Error loading categories": "Error loading categories",
    
    "Products": "Products",
    "New Product": "New Product",
    "Edit Product": "Edit Product",
    "Create New Product": "Create New Product",
    "Update Product": "Update Product",
    "Create Product": "Create Product",
    "Delete Product": "Delete Product",
    "Product ID (e.g., burger-classic)": "Product ID (e.g., burger-classic)",
    "Title *": "Title *",
    "Subtitle": "Subtitle",
    "Variants, Volumes & Prices": "Variants, Volumes & Prices",
    "Variant": "Variant",
    "Volume": "Volume",
    "Price": "Price",
    "Add Variant": "Add Variant",
    "Variant %d (e.g., Small)": "Variant %d (e.g., Small)",
    "Volume (e.g., 250ml)": "Volume (e.g., 250ml)",
    "Each variant must have a volume and price": "Each variant must have a volume and price",
    "Order (optional)": "Order (optional)",
    "Published:": "Published:",
    "Available:": "Available:",
    "Yes": "Yes",
    "No": "No",
    "Product Options (optional)": "Product Options (optional)",
    "Add Option": "Add Option",
    "Option %d": "Option %d",
    "Option Title (e.g., Choose Size)": "Option Title (e.g., Choose Size)",
    "Type:": "Type:",
    "Conf (single)": "Conf (single)",
    "Add (multiple)": "Add (multiple)",
    "Required:": "Required:",
    "Choices": "Choices",
    "Add Choice": "Add Choice",
    "Choice %d (e.g., Large)": "Choice %d (e.g., Large)",
    "Prices per variant (additional cost):": "Prices per variant (additional cost):",
    "Product created successfully": "Product created successfully",
    "Product updated successfully": "Product updated successfully",
    "Product deleted successfully": "Product deleted successfully",
    "Failed to create product": "Failed to create product",
    "Failed to update product": "Failed to update product",
    "Failed to delete product": "Failed to delete product",
    "Please fill in required fields (ID, Category, Title)": "Please fill in required fields (ID, Category, Title)",
    "At least one variant is required": "At least one variant is required",
    "Number of prices must match number of variants": "Number of prices must match number of variants",
    "Number of volumes must match number of variants": "Number of volumes must match number of variants",
    "Must have at least one variant": "Must have at least one variant",
    "Filter by Category:": "Filter by Category:",
    "All Categories": "All Categories",
    "Published": "Published",
    "Unpublished": "Unpublished",
    "Available": "Available",
    "Unavailable": "Unavailable",
    "Variants:": "Variants:",
    "Volumes:": "Volumes:",
    "Prices:": "Prices:",
    "Options:": "Options:",
    "Upload Image": "Upload Image",
    "Delete Image": "Delete Image",
    "Image uploaded successfully": "Image uploaded successfully",
    "Image deleted successfully": "Image deleted successfully",
    "Failed to upload image": "Failed to upload image",
    "Failed to delete image": "Failed to delete image",
    "Permission Required": "Permission Required",
    "Permission to access media library is required!": "Permission to access media library is required!",
    "Are you sure you want to delete this image?": "Are you sure you want to delete this image?",
    "Are you sure you want to delete": "Are you sure you want to delete",
    "Options are extras/customizations like size, toppings, etc. Each choice has prices per variant.": "Options are extras/customizations like size, toppings, etc. Each choice has prices per variant.",
    "No options added. Options allow customers to customize their order (e.g., size, toppings).": "No options added. Options allow customers to customize their order (e.g., size, toppings).",

    // Nizza
    средна: "средна",
    голяма: "голяма",
    Пица: "Пица",
    Бургери: "Бургери",
    Гарнитури: "Гарнитури",
    Десерти: "Десерти",
    Сосове: "Сосове",
    Порции: "Порции",
    Сандвичи: "Сандвичи",
    Салати: "Салати",
    "From:": "От:",
    "City:": "Град:",
    "Street:": "Улица:",
    "Comment:": "Коментар:",
    Deliveries: "Доставки",
    Delivery: "Доставка",
    "Phone:": "Тел:",
    "Добавкa": "Добавка",
    Тесто: "Тесто",
    "Сусамово семе": "Сусамово семе",
    "Слънчогледово семе": "Слънчогледово семе",
    "Ленено семе": "Ленено семе",
    "Маково семе": "Маково семе",
    Борд: "Борд",
    Моцарела: "Моцарела",
    Чеснов: "Чеснов",
    Чедър: "Чедър",
    Филаделфия: "Филаделфия",
    "": "",
  'Маргарита': 'Маргарита',
  'Доматен сос и моцарела': 'Доматен сос и моцарела',
  'малка - 26 см': 'малка - 26 см',
  'Пресни домати': 'Пресни домати',
  'Чери домати': 'Чери домати',
  'Кисели краставички': 'Кисели краставички',
  'Сушени домати': 'Сушени домати',
  'Карамелизиран Лук': 'Карамелизиран Лук',
  'Халапеньо': 'Халапеньо',
  'Авокадо': 'Авокадо',
  'Свинска шунка': 'Свинска шунка',
  'Бекон': 'Бекон',
  'Пилешка шунка': 'Пилешка шунка',
  'Луканков салам': 'Луканков салам',
  'Прошуто': 'Прошуто',
  'Пеперони': 'Пеперони',
  'Кюфте': 'Кюфте',
  'Свинско Конци': 'Свинско Конци',
  'Пилешко филе': 'Пилешко филе',
  'Доматен сос': 'Доматен сос',
  'Сметана': 'Сметана',
  'Моцарела': 'Моцарела',
  'Синьо сирене': 'Синьо сирене',
  'Пармезан': 'Пармезан',
  'Бяло сирене': 'Бяло сирене',
  'Пушено сирене': 'Пушено сирене',
  'Яйце': 'Яйце',
  'Рукола': 'Рукола',
  'Айсберг': 'Айсберг',
  'Зелена чушка': 'Зелена чушка',
  'Гъби': 'Гъби',
  'Царевица': 'Царевица',
  'Червен лук': 'Червен лук',
  'Маслини': 'Маслини',
  'Люта чушка': 'Люта чушка',
  'Куатро Формаджи': 'Куатро Формаджи',
  'Доматен сос, моцарела, синьо сирене, чедър и топено сирене': 'Доматен сос, моцарела, синьо сирене, чедър и топено сирене',
  'Куатро Ди Карне': 'Куатро Ди Карне',
  'Доматен сос, моцарела, шунка, пилешко филе, бекон и луканов салам': 'Доматен сос, моцарела, шунка, пилешко филе, бекон и луканов салам',
  'Капричоза': 'Капричоза',
  'Доматен сос, моцарела, шунка, гъби и чушки': 'Доматен сос, моцарела, шунка, гъби и чушки',
  'Поло': 'Поло',
  'Доматен сос, моцарела, пилешко филе, гъби и чушки': 'Доматен сос, моцарела, пилешко филе, гъби и чушки',
  'Карбонара': 'Карбонара',
  'Сметанов сос, моцарела, бекон, гъби и пармезан': 'Сметанов сос, моцарела, бекон, гъби и пармезан',
  'Ница': 'Ница',
  'Доматен сос, моцарела, шунка, бекон, гъби и сметана': 'Доматен сос, моцарела, шунка, бекон, гъби и сметана',
  'Диаволо': 'Диаволо',
  'Доматен сос, моцарела, шунка, пеперони, люта чушка и чери домати': 'Доматен сос, моцарела, шунка, пеперони, люта чушка и чери домати',
  'Американо BBQ': 'Американо BBQ',
  'Доматен сос, BBQ сос, горчица, моцарела, пилешко филе, пеперони, чушки и маслини': 'Доматен сос, BBQ сос, горчица, моцарела, пилешко филе, пеперони, чушки и маслини',
  'Алфредо': 'Алфредо',
  'Сметанов сос, моцарела, пилешко филе, царевица и топено сирене': 'Сметанов сос, моцарела, пилешко филе, царевица и топено сирене',
  'Доматен сос, моцарела и пеперони': 'Доматен сос, моцарела и пеперони',
  'Мексикана': 'Мексикана',
  'Доматен сос, моцарела, пеперони, червен лук, маслини, царевица, люта чушка': 'Доматен сос, моцарела, пеперони, червен лук, маслини, царевица, люта чушка',
  'Италия': 'Италия',
  'Доматен сос, моцарела, сушени домати, пармезан и песто': 'Доматен сос, моцарела, сушени домати, пармезан и песто',
  'Салами': 'Салами',
  'Доматен сос, моцарела, луканков салам, чушка и маслини': 'Доматен сос, моцарела, луканков салам, чушка и маслини',
  'Вегетариана': 'Вегетариана',
  'Доматен сос, моцарела, гъби, царевица, чушка, червен лук и маслини': 'Доматен сос, моцарела, гъби, царевица, чушка, червен лук и маслини',
  'Прошуто фунги': 'Прошуто фунги',
  'Доматен сос, моцарела, прошуто крудо, гъби, рукола и пармезан': 'Доматен сос, моцарела, прошуто крудо, гъби, рукола и пармезан',
  'Бургер Пица': 'Бургер Пица',
  'Доматен сос, моцарела, телешко, халапеньо, чедър и гъби': 'Доматен сос, моцарела, телешко, халапеньо, чедър и гъби',
  'Сицилиана': 'Сицилиана',
  'Доматен сос, моцарела, пилешко филе, сушени домати, топени сирене и песто': 'Доматен сос, моцарела, пилешко филе, сушени домати, топени сирене и песто',
  'Калцоне': 'Калцоне',
  'Доматен сос, моцарела, шунка, гъби, кисели краствички': 'Доматен сос, моцарела, шунка, гъби, кисели краствички',
  'средна - 30 см': 'средна - 30 см',
  'голяма - 50 см': 'голяма - 50 см',
  'Ница Бургер': 'Ница Бургер',
  'Питка бриош, айсберг, домат, телешко, чедър, яйце, бекон, карамелизиран лук и ница сос': 'Питка бриош, айсберг, домат, телешко, чедър, яйце, бекон, карамелизиран лук и ница сос',
  'Класик Бургер': 'Класик Бургер',
  'Питка бриош, айсберг, кисели краставички, телешко, ница сос': 'Питка бриош, айсберг, кисели краставички, телешко, ница сос',
  'Чийз Бургер': 'Чийз Бургер',
  'Питка бриош, айсберг, кисели краставици, домат, телешко, чедър, червен лук и ница сос': 'Питка бриош, айсберг, кисели краставици, домат, телешко, чедър, червен лук и ница сос',
  'Пилешки Бургер': 'Пилешки Бургер',
  'Питка бриош, рукола, сушени домати, гриловано пилешко, червен лук, ементал и домашна майонеза': 'Питка бриош, рукола, сушени домати, гриловано пилешко, червен лук, ементал и домашна майонеза',
  'Криспи Чикън Бургер': 'Криспи Чикън Бургер',
  'Питка бриош, айсберг, кисели краставици, хрупкаво, панирано пилешко филе, бекон и японска майонеза': 'Питка бриош, айсберг, кисели краставици, хрупкаво, панирано пилешко филе, бекон и японска майонеза',
  'Смоуки Бургер': 'Смоуки Бургер',
  'Питка бриош, айсберг, телешко, бекон, лучени кръгчета, моцарела и ница сос': 'Питка бриош, айсберг, телешко, бекон, лучени кръгчета, моцарела и ница сос',
  'Пулд Порк Бургер': 'Пулд Порк Бургер',
  'Питка бриош, айсберг, кисели краставици, бавно готвено свинско месо, чедър, карамелизиран лук и барбекю сос': 'Питка бриош, айсберг, кисели краставици, бавно готвено свинско месо, чедър, карамелизиран лук и барбекю сос',
  'Спайси Найси Бургер': 'Спайси Найси Бургер',
  'Питка бриош, телешко, айсберг, чедър, халапеньо, доматено пикантно чътни и ница сос': 'Питка бриош, телешко, айсберг, чедър, халапеньо, доматено пикантно чътни и ница сос',
  'Веджи Бургер': 'Веджи Бургер',
  'Бургер от киноа и халуми, айсберг, чедър, домат, кисели краставички, червен лук': 'Бургер от киноа и халуми, айсберг, чедър, домат, кисели краставички, червен лук',
  'Детски Бургер (МЕНЮ)': 'Детски Бургер (МЕНЮ)',
  'Питка бриош, телешко, чедър, домат, кисели краставички и майонеза + пържени картофки и плодов сок': 'Питка бриош, телешко, чедър, домат, кисели краставички и майонеза + пържени картофки и плодов сок',
  'Лучени кръгчета': 'Лучени кръгчета',
  '200 гр': '200 гр',
  'Пържени картофи': 'Пържени картофи',
  'Хрупкави пилешки филенца': 'Хрупкави пилешки филенца',
  'хрупкави панирани пилешки филенца с чеснов сос': 'хрупкави панирани пилешки филенца с чеснов сос',
  'Порция с хрупкаво пиле': 'Порция с хрупкаво пиле',
  'Панирано филе, басмати ориз, микс салатки': 'Панирано филе, басмати ориз, микс салатки',
  'Порция пилешко филе': 'Порция пилешко филе',
  'Пилешко филе, басмати ориз, микс салатки  ': 'Пилешко филе, басмати ориз, микс салатки  ',
  'Порция телешко': 'Порция телешко',
  '2бр. телешки кюфтенца, басмати ориз, микс салатки': '2бр. телешки кюфтенца, басмати ориз, микс салатки',
  'Порция веджи': 'Порция веджи',
  'Кюфтенце от киноа, басмати ориз, микс салатки': 'Кюфтенце от киноа, басмати ориз, микс салатки',
  'Ницета с пеперони': 'Ницета с пеперони',
  'Пеперони, моцарела и масло': 'Пеперони, моцарела и масло',
  'Ницета с шунка': 'Ницета с шунка',
  'Шунка, моцарела и масло': 'Шунка, моцарела и масло',
  'Ницета с пилешко филе': 'Ницета с пилешко филе',
  'Пилешко филе, моцарела и масло': 'Пилешко филе, моцарела и масло',
  'Ницета с бекон': 'Ницета с бекон',
  'Бекон, моцарела и масло': 'Бекон, моцарела и масло',
  'Тортиля НИЦА': 'Тортиля НИЦА',
  'Мляно свинско – телешко месо,айсберг, домат, кисела краставичка,моцарела,карамелизиран лук,картофки,ница сос': 'Мляно свинско – телешко месо,айсберг, домат, кисела краставичка,моцарела,карамелизиран лук,картофки,ница сос',
  'Тортиля с пилешко': 'Тортиля с пилешко',
  'Пилешко филе,моцарела, рукола, сушени домати, червен лук, картофки, домашна майонеза': 'Пилешко филе,моцарела, рукола, сушени домати, червен лук, картофки, домашна майонеза',
  'Тортиля със свинско': 'Тортиля със свинско',
  'Бавно готвено свинско, айсберг, кисели краставички,айсберг,карамелизиран лук, картофки, моцарела,BBQ сос': 'Бавно готвено свинско, айсберг, кисели краставички,айсберг,карамелизиран лук, картофки, моцарела,BBQ сос',
  'Тортиля с хрупкаво пиле': 'Тортиля с хрупкаво пиле',
  'Хрупкаво панирано пилешко, айсберг, кисели краставички, домат,  моцарела, картофки, чеснов сос': 'Хрупкаво панирано пилешко, айсберг, кисели краставички, домат,  моцарела, картофки, чеснов сос',
  'Джоб Ница': 'Джоб Ница',
  'Телешко, айсберг, домати, кисели краставички ,моцарела, карамелизиран лук, картофи , ница сос': 'Телешко, айсберг, домати, кисели краставички ,моцарела, карамелизиран лук, картофи , ница сос',
  'Джоб Пулд порк': 'Джоб Пулд порк',
  'Бавно готвено свинско, айсберг, кисели краставички, червен лук, чедър, картофи, BBQ сос': 'Бавно готвено свинско, айсберг, кисели краставички, червен лук, чедър, картофи, BBQ сос',
  'Джоб Чийз BBQ бекон': 'Джоб Чийз BBQ бекон',
  'Хрупков бекон, чедър, айсберг, домат, червен лук, картофи, BBQ сос': 'Хрупков бекон, чедър, айсберг, домат, червен лук, картофи, BBQ сос',
  'Джоб Поло': 'Джоб Поло',
  'Пилешка шунка, моцарела, айсберг, домат, картофи, чеснов сос': 'Пилешка шунка, моцарела, айсберг, домат, картофи, чеснов сос',
  'Джоб Вегетериански': 'Джоб Вегетериански',
  'Моцарела, чедър, топено сирене, яйце, картофи, айсберг, домат, ница сос': 'Моцарела, чедър, топено сирене, яйце, картофи, айсберг, домат, ница сос',
  'Джоб Капризен': 'Джоб Капризен',
  'Прошуто кото, айсберг, домат, зелена чушка, моцарела, каротфи, майонеза': 'Прошуто кото, айсберг, домат, зелена чушка, моцарела, каротфи, майонеза',
  'Джоб сандвич Мексикански': 'Джоб сандвич Мексикански',
  'Телешко, домати, айсберг, царевица, халапеньо, червен лук, картофи, чили сос': 'Телешко, домати, айсберг, царевица, халапеньо, червен лук, картофи, чили сос',
  'Салата Цезар': 'Салата Цезар',
  'Айсберг, сос Цезар, пилешки филенца, чери домати, бекон, кротони и пармезан - 350 гр': 'Айсберг, сос Цезар, пилешки филенца, чери домати, бекон, кротони и пармезан - 350 гр',
  'Айсберг с рукола': 'Айсберг с рукола',
  'Айсберг, рукола, чери домати, сос Винегрет, пармезан - 250 гр': 'Айсберг, рукола, чери домати, сос Винегрет, пармезан - 250 гр',
  'Домати с печена чушка': 'Домати с печена чушка',
  'Белени домати, печени чушки, маслина, сирене, зехтин 400гр': 'Белени домати, печени чушки, маслина, сирене, зехтин 400гр',
  'Капрезе': 'Капрезе',
  'Домати, свежа моцарела, песто, рукола и пармезан - 400 гр': 'Домати, свежа моцарела, песто, рукола и пармезан - 400 гр',
  'Салата Кобб': 'Салата Кобб',
  'Айсберг, пилешко филе, сушени домати, авокадо, бекон, синьо сирене и лимонов дресинг - 350 гр': 'Айсберг, пилешко филе, сушени домати, авокадо, бекон, синьо сирене и лимонов дресинг - 350 гр',
  'Салата хрупкаво пиле': 'Салата хрупкаво пиле',
  'Айсбег, домат, царевица, панирано пиле, чеснов сос, пармезан': 'Айсбег, домат, царевица, панирано пиле, чеснов сос, пармезан',
  'Шоколадова кариолка': 'Шоколадова кариолка',
  'Шоколад , масло , ядки - 70 гр. / бр': 'Шоколад , масло , ядки - 70 гр. / бр',
  'Крем Ден и нощ': 'Крем Ден и нощ',
  'масло, сметана, шоколад, пандишпан, ядки - 160 гр. / бр': 'масло, сметана, шоколад, пандишпан, ядки - 160 гр. / бр',
  'Кока кола – 330ml': 'Кока кола – 330ml',
  '': '',
  'Фанта Портокал – 330ml': 'Фанта Портокал – 330ml',
  'Спрайт – 330ml': 'Спрайт – 330ml',
  'Кока кола – 500мл': 'Кока кола – 500мл',
  'Фанта Портокал – 500мл': 'Фанта Портокал – 500мл',
  'Спрайт – 500мл': 'Спрайт – 500мл',
  'Фанта Лимон – 500мл': 'Фанта Лимон – 500мл',
  'Кока кола – 2L': 'Кока кола – 2L',
  'Фанта Портокал – 2L': 'Фанта Портокал – 2L',
  'Нестий праскова – 500ml': 'Нестий праскова – 500ml',
  'Нестий лимон – 500ml': 'Нестий лимон – 500ml',
  'Нестий горски плод – 500ml': 'Нестий горски плод – 500ml',
  'Нестий манго и ананас – 500ml': 'Нестий манго и ананас – 500ml',
  'Минерална вода – 500ml': 'Минерална вода – 500ml',
  'Минерална вода – 1,5L': 'Минерална вода – 1,5L',
  'Айран – 330ml': 'Айран – 330ml',
  'Загорка кен – 500ml': 'Загорка кен – 500ml',
  'Хайникен кен – 500ml': 'Хайникен кен – 500ml',
  'Хайнекен 330': 'Хайнекен 330',
  'Кетчуп': 'Кетчуп',
  '50 гр': '50 гр',
  'Майонеза': 'Майонеза',
  'Горчица': 'Горчица',
  'Чили сос': 'Чили сос',
  'Чеснов сос': 'Чеснов сос',
  'Барбекю': 'Барбекю',
  'Сладко чили': 'Сладко чили',
  'Цезар': 'Цезар',
  'Песто': 'Песто',
  'Ница сос': 'Ница сос'

      },
  it: {
    "Поръчай тук": "Ordina qui",
    "Кафе Верняно": "Caffè Vergnano",
    "Кафе Верняно - промо 10:00": "Caffè Vergnano - promo 10:00",
    Фреш: "Succo fresco",
    "Кафе Верняно - 100% Арабика": "Caffè Vergnano - 100% Arabica",
    "Кафе Верняно - Безкофеиново": "Caffè Vergnano - Decaffeinato",
    Банкя: "Aqua Minerale Naturale",
    "Кока-Кола": "Coca-Cola",
    Капи: "succo Cappy",
    Швепс: "Schweppes",
    Спрайт: "Sprite",
    "Студен чай": "Tè Freddo",
    Чай: "Tè",
    Сода: "Acqua Minerale Frizzante",
    "3в1": "Nescafe 3in1",
    Лате: "Latte",
    Лимонада: "Limonata",
    Фрапе: "Frappé",
    Нескафе: "Nescafé",
    "Капучино Верняно": "Cappuccino Vergnano",
    "Мляко с какао Верняно": "Vergnano Latte al cioccolato",
    "Топъл Шоколад Верняно": "Vergnano Cioccolata Calda",
    "Външна батерия": "Caricabatterie",
    Цитронада: "Citronata",
    Самърсби: "Sidro Sommersby",
    "Банкя - стъклена бутилка": "Aqua Minerale Naturale - bottiglia di vetro",
    Корона: "Corona",
    "Jack Daniel's Honey Lemonade": "Jack Daniel's Limonata di miele",
    "Bickens Pink & Pink Tonic Style": "Bickens Pink & Pink Tonic Style",
    "Bacardi Mojito": "Bacardi Mojito",
    Шот: "Shottino",
    Шейкър: "Shaker",
    Фанта: "Fanta",
    Загорка: "Birra Zagorka",
    "Хайникен наливна": "Heineken alla spina",
    Шприц: "Spriz",
    Аперол: "Aperol",
    Лимончело: "Limoncello",
    Маркати: "Marcati",
    Мартини: "Martini",
    Бианко: "Bianco",
    Кампари: "Campari",
    Бакарди: "Bacardi",
    Ликьор: "Amaro",
    Дисароно: "Disaronno",
    Бушмилс: "Bushmills",
    Джони: "Johnnie Walker",
    Джеймсън: "Jameson",
    "J&B": "J&B",
    "Джак Даниелс": "Jack Daniels",
    "Сингъл Барел": "Single Barrel",
    Житная: "Zytnia",
    Абсолют: "Absolut",
    "Руски Стандарт": "Russkii Standart",
    Финландия: "Finlandia",
    Бифитър: "Beefeater",
    Горданс: "Gordon's",
    "Горданс Пинк": "Gordon's Pink",
    Джин: "Gin",
    Бомбай: "Bombay",
    Узо: "Ouzo",
    12: "12",
    7: "7",
    Пломари: "Plomari",
    Тсантали: "Tsantali",
    "Чивас Регал": "Chivas Regal",
    Кардю: "Cardhu",
    "Джентълмен Джак": "Gentleman Jack",
    Гленфидиш: "Glenfiddich",
    РедБул: "RedBull",
    "Сайкъл Сов Блан": "Cycle Sauvignon blanc",
    Столично: "Stolichno",
    Хайникен: "Heineken",
    Ариана: "Arianna",
    Старобърно: "Starobrno",
    Ботега: "Bottega",
    Морети: "Moretti",
    "Афтър Шок": "After Shock",
    Савой: "Savoy",
    "Зельоная Марка": "Green Mark",
    Столичная: "Stolichnaya",
    Търговище: "Targovishte",
    "Грей Гус": "Gray Goose",
    Белуга: "Beluga",
    "Бургас 63": "Burgas 63",
    "Бургаска Мускатова": "Uva Moscato di Burgas",
    "Кайлъшка гроздова": "Kaylashka",
    Карнобатска: "Karnobatska",
    Пещерска: "Peshterska",
    "Плиска Преслав": "Pliska Preslav",
    "Мента Пещера": "Peshtera Mint",
    "Къти Сарк": "Cutty Sark",
    "Джийм Бийм": "Jim Beam",
    "Джак Даниелс": "Jack",
    Грантс: "Grants",
    Метакса: "Metaxa",
    "Сайкъл Траминер": "Cycle Traminer",
    "Сайкъл Мерло и Пино Ноар": "Cycle Merlot & Pinot noir",
    "Сайкъл Розе": "Cycle Rose",
    "Едоардо Миролио Совиньон Блан": "Edoardo Miroglio Sauvignon Blanc",
    "JP Chenet - 250 мл": "JP. Chenet - 250 ml.",
    "Моет Шандон Брут": "Moët & Chandon Impérial Brut",
    Напитки: "Bevande",
    Коктейли: "Cocktail",
    "Друг алкохол": "Altro alcol",

    Кафетерия: "Caffetteria",
    Топли: "Calde",
    Фрешове: "Succhi",
    късо: "Corto",
    нормално: "Espresso",
    дълго: "Lungo",
    лв: "BGN",
    "25 мл": "25 ml.",
    "300 мл": "300 ml.",
    "50 мл": "50 ml.",
    "200 мл": "200 ml.",
    "250 мл": "250 ml.",
    "330 мл": "330 ml.",
    "350 мл": "350 ml.",
    "355 мл": "355 ml.",
    "375 мл": "375 ml.",
    "250 мл": "250 ml.",
    "500 мл": "500 ml.",
    "750 мл": "750 ml.",
    Безалкохолни: "Bevande",
    Бири: "Birre",
    Водка: "Vodka",
    Уиски: "Whisky",
    "без захар": "zero",
    "с лимон": "gusto limone",
    портокал: "arancia",
    праскова: "pesca",
    кайсия: "albicocca",
    ананас: "ananas",
    мандарина: "mandarino",
    тоник: "tonica",
    лимон: "limone",
    нар: "melograno",
    зелен: "verde",
    "горски плодове": "frutti di bosco",
    бяло: "bianco",
    черно: "nero",
    "-": "-",
    ягода: "fragola",
    "лайм-джинджър": "lime-zenzero",
    мента: "menta",
    топло: "caldo",
    студено: "freddo",
    черен: "fondente",
    бял: "bianca",
    "с кокос": "cocco",
    лате: "latte",
    "Micro USB": "Micro USB",
    "USB C": "USB C",
    iPhone: "iPhone",
    Боровинка: "mirtillo",
    Ябълка: "mela",
    Круша: "pera",
    Манго: "mango",
    грейпфрут: "pompelmo",
    микс: "misto",
    малко: "singolo",
    червено: "rosso",
    малка: "singolo",
    "12 годишно": "12 anni",
    боквайс: "bock weiss",
    вайс: "weiss",
    традиционна: "tradizionale",
    розе: "rose",

    "Additional comment:": "Note\naggiuntive:",
    "Table closed": "Tavolo chiuso",
    "This table is already closed. Please ask staff to open a new table.": "Questo tavolo e gia chiuso. Chiedi allo staff di aprire un nuovo tavolo.",
    "Failed to add item to table": "Impossibile aggiungere l'articolo al tavolo",

    // Landing page
    "Harlem": "Harlem",
    "Harlem by Refraction X": "Harlem by Refraction X",
    "Food, drinks, gaming": "Cibo, bevande, gaming",
    "Order from the bar, check the menu, or jump into the venue app.": "Ordina dal bar, consulta il menu o entra nell'app del locale.",
    "Burger Nizza": "Burger Nizza",
    "Burgers, sides, delivery": "Burger, contorni, consegna",
    "Order online, check the menu, or choose pickup and delivery.": "Ordina online, consulta il menu o scegli ritiro e consegna.",
    "Order, pickup, delivery": "Ordini, ritiro, consegna",
    "Order online, check the menu, or continue into the venue app.": "Ordina online, consulta il menu o continua nell'app del locale.",
    "Order now": "Ordina ora",
    "Online orders": "Ordini online",
    "Pickup or delivery": "Ritiro o consegna",
    "Menu": "Menu",
    "Food and drinks": "Cibo e bevande",
    "E-sports": "E-sports",
    "PC stations": "Postazioni PC",
    "VR": "VR",
    "Virtual reality": "Realta virtuale",
    "Featured": "In evidenza",
    "Ready when you are": "Pronto quando vuoi",
    "Start order": "Inizia ordine",
    "Operator": "Operatore",

    // Category and Product Management
    "Categories": "Categorie",
    "Create New Category": "Crea nuova categoria",
    "Category ID (e.g., burgers)": "ID categoria (es., burgers)",
    "Category Name": "Nome categoria",
    "Order": "Ordine",
    "Name": "Nome",
    "Create Category": "Crea categoria",
    "Category created successfully": "Categoria creata con successo",
    "Category updated successfully": "Categoria aggiornata con successo",
    "Category deleted successfully": "Categoria eliminata con successo",
    "Failed to create category": "Impossibile creare la categoria",
    "Failed to update category": "Impossibile aggiornare la categoria",
    "Failed to delete category": "Impossibile eliminare la categoria",
    "Please enter both category ID and name": "Inserisci sia l'ID che il nome della categoria",
    "Delete Category": "Elimina categoria",
    "Error loading categories": "Errore nel caricamento delle categorie",
    
    "Products": "Prodotti",
    "New Product": "Nuovo prodotto",
    "Edit Product": "Modifica prodotto",
    "Create New Product": "Crea nuovo prodotto",
    "Update Product": "Aggiorna prodotto",
    "Create Product": "Crea prodotto",
    "Delete Product": "Elimina prodotto",
    "Product ID (e.g., burger-classic)": "ID prodotto (es., burger-classic)",
    "Title *": "Titolo *",
    "Subtitle": "Sottotitolo",
    "Variants, Volumes & Prices": "Varianti, volumi e prezzi",
    "Variant": "Variante",
    "Volume": "Volume",
    "Price": "Prezzo",
    "Add Variant": "Aggiungi variante",
    "Variant %d (e.g., Small)": "Variante %d (es., Piccolo)",
    "Volume (e.g., 250ml)": "Volume (es., 250ml)",
    "Each variant must have a volume and price": "Ogni variante deve avere un volume e un prezzo",
    "Order (optional)": "Ordine (opzionale)",
    "Published:": "Pubblicato:",
    "Available:": "Disponibile:",
    "Yes": "Sì",
    "No": "No",
    "Product Options (optional)": "Opzioni prodotto (opzionale)",
    "Add Option": "Aggiungi opzione",
    "Option %d": "Opzione %d",
    "Option Title (e.g., Choose Size)": "Titolo opzione (es., Scegli dimensione)",
    "Type:": "Tipo:",
    "Conf (single)": "Conf (scelta singola)",
    "Add (multiple)": "Add (multiplo)",
    "Required:": "Obbligatorio:",
    "Choices": "Scelte",
    "Add Choice": "Aggiungi scelta",
    "Choice %d (e.g., Large)": "Scelta %d (es., Grande)",
    "Prices per variant (additional cost):": "Prezzi per variante (costo aggiuntivo):",
    "Product created successfully": "Prodotto creato con successo",
    "Product updated successfully": "Prodotto aggiornato con successo",
    "Product deleted successfully": "Prodotto eliminato con successo",
    "Failed to create product": "Impossibile creare il prodotto",
    "Failed to update product": "Impossibile aggiornare il prodotto",
    "Failed to delete product": "Impossibile eliminare il prodotto",
    "Please fill in required fields (ID, Category, Title)": "Compila i campi obbligatori (ID, Categoria, Titolo)",
    "At least one variant is required": "È richiesta almeno una variante",
    "Number of prices must match number of variants": "Il numero di prezzi deve corrispondere al numero di varianti",
    "Number of volumes must match number of variants": "Il numero di volumi deve corrispondere al numero di varianti",
    "Must have at least one variant": "Deve avere almeno una variante",
    "Filter by Category:": "Filtra per categoria:",
    "All Categories": "Tutte le categorie",
    "Published": "Pubblicato",
    "Unpublished": "Non pubblicato",
    "Available": "Disponibile",
    "Unavailable": "Non disponibile",
    "Variants:": "Varianti:",
    "Volumes:": "Volumi:",
    "Prices:": "Prezzi:",
    "Options:": "Opzioni:",
    "Upload Image": "Carica immagine",
    "Delete Image": "Elimina immagine",
    "Image uploaded successfully": "Immagine caricata con successo",
    "Image deleted successfully": "Immagine eliminata con successo",
    "Failed to upload image": "Impossibile caricare l'immagine",
    "Failed to delete image": "Impossibile eliminare l'immagine",
    "Permission Required": "Permesso richiesto",
    "Permission to access media library is required!": "È richiesto il permesso per accedere alla libreria multimediale!",
    "Are you sure you want to delete this image?": "Sei sicuro di voler eliminare questa immagine?",
    "Are you sure you want to delete": "Sei sicuro di voler eliminare",
    "Options are extras/customizations like size, toppings, etc. Each choice has prices per variant.": "Le opzioni sono extra/personalizzazioni come dimensione, condimenti, ecc. Ogni scelta ha prezzi per variante.",
    "No options added. Options allow customers to customize their order (e.g., size, toppings).": "Nessuna opzione aggiunta. Le opzioni consentono ai clienti di personalizzare il loro ordine (es., dimensione, condimenti).",

    // Nizza
  средна: "средна",
    голяма: "голяма",
    Пица: "Пица",
    Бургери: "Бургери",
    Гарнитури: "Гарнитури",
    Десерти: "Десерти",
    Сосове: "Сосове",
    Порции: "Порции",
    Сандвичи: "Сандвичи",
    Салати: "Салати",
    "From:": "От:",
    "City:": "Град:",
    "Street:": "Улица:",
    "Comment:": "Коментар:",
    Deliveries: "Доставки",
    Delivery: "Доставка",
    "Phone:": "Тел:",
    Добавка: "Добавка",
    Тесто: "Тесто",
    "Сусамово семе": "Сусамово семе",
    "Слънчогледово семе": "Слънчогледово семе",
    "Ленено семе": "Ленено семе",
    "Маково семе": "Маково семе",
    Борд: "Борд",
    Моцарела: "Моцарела",
    Чеснов: "Чеснов",
    Чедър: "Чедър",
    Филаделфия: "Филаделфия",
    "": "",

  'Маргарита': 'Маргарита',
  'Доматен сос и моцарела': 'Доматен сос и моцарела',
  'малка - 26 см': 'малка - 26 см',
  'Пресни домати': 'Пресни домати',
  'Чери домати': 'Чери домати',
  'Кисели краставички': 'Кисели краставички',
  'Сушени домати': 'Сушени домати',
  'Карамелизиран Лук': 'Карамелизиран Лук',
  'Халапеньо': 'Халапеньо',
  'Авокадо': 'Авокадо',
  'Свинска шунка': 'Свинска шунка',
  'Бекон': 'Бекон',
  'Пилешка шунка': 'Пилешка шунка',
  'Луканков салам': 'Луканков салам',
  'Прошуто': 'Прошуто',
  'Пеперони': 'Пеперони',
  'Кюфте': 'Кюфте',
  'Свинско Конци': 'Свинско Конци',
  'Пилешко филе': 'Пилешко филе',
  'Доматен сос': 'Доматен сос',
  'Сметана': 'Сметана',
  'Моцарела': 'Моцарела',
  'Синьо сирене': 'Синьо сирене',
  'Пармезан': 'Пармезан',
  'Бяло сирене': 'Бяло сирене',
  'Пушено сирене': 'Пушено сирене',
  'Яйце': 'Яйце',
  'Рукола': 'Рукола',
  'Айсберг': 'Айсберг',
  'Зелена чушка': 'Зелена чушка',
  'Гъби': 'Гъби',
  'Царевица': 'Царевица',
  'Червен лук': 'Червен лук',
  'Маслини': 'Маслини',
  'Люта чушка': 'Люта чушка',
  'Куатро Формаджи': 'Куатро Формаджи',
  'Доматен сос, моцарела, синьо сирене, чедър и топено сирене': 'Доматен сос, моцарела, синьо сирене, чедър и топено сирене',
  'Куатро Ди Карне': 'Куатро Ди Карне',
  'Доматен сос, моцарела, шунка, пилешко филе, бекон и луканов салам': 'Доматен сос, моцарела, шунка, пилешко филе, бекон и луканов салам',
  'Капричоза': 'Капричоза',
  'Доматен сос, моцарела, шунка, гъби и чушки': 'Доматен сос, моцарела, шунка, гъби и чушки',
  'Поло': 'Поло',
  'Доматен сос, моцарела, пилешко филе, гъби и чушки': 'Доматен сос, моцарела, пилешко филе, гъби и чушки',
  'Карбонара': 'Карбонара',
  'Сметанов сос, моцарела, бекон, гъби и пармезан': 'Сметанов сос, моцарела, бекон, гъби и пармезан',
  'Ница': 'Ница',
  'Доматен сос, моцарела, шунка, бекон, гъби и сметана': 'Доматен сос, моцарела, шунка, бекон, гъби и сметана',
  'Диаволо': 'Диаволо',
  'Доматен сос, моцарела, шунка, пеперони, люта чушка и чери домати': 'Доматен сос, моцарела, шунка, пеперони, люта чушка и чери домати',
  'Американо BBQ': 'Американо BBQ',
  'Доматен сос, BBQ сос, горчица, моцарела, пилешко филе, пеперони, чушки и маслини': 'Доматен сос, BBQ сос, горчица, моцарела, пилешко филе, пеперони, чушки и маслини',
  'Алфредо': 'Алфредо',
  'Сметанов сос, моцарела, пилешко филе, царевица и топено сирене': 'Сметанов сос, моцарела, пилешко филе, царевица и топено сирене',
  'Доматен сос, моцарела и пеперони': 'Доматен сос, моцарела и пеперони',
  'Мексикана': 'Мексикана',
  'Доматен сос, моцарела, пеперони, червен лук, маслини, царевица, люта чушка': 'Доматен сос, моцарела, пеперони, червен лук, маслини, царевица, люта чушка',
  'Италия': 'Италия',
  'Доматен сос, моцарела, сушени домати, пармезан и песто': 'Доматен сос, моцарела, сушени домати, пармезан и песто',
  'Салами': 'Салами',
  'Доматен сос, моцарела, луканков салам, чушка и маслини': 'Доматен сос, моцарела, луканков салам, чушка и маслини',
  'Вегетариана': 'Вегетариана',
  'Доматен сос, моцарела, гъби, царевица, чушка, червен лук и маслини': 'Доматен сос, моцарела, гъби, царевица, чушка, червен лук и маслини',
  'Прошуто фунги': 'Прошуто фунги',
  'Доматен сос, моцарела, прошуто крудо, гъби, рукола и пармезан': 'Доматен сос, моцарела, прошуто крудо, гъби, рукола и пармезан',
  'Бургер Пица': 'Бургер Пица',
  'Доматен сос, моцарела, телешко, халапеньо, чедър и гъби': 'Доматен сос, моцарела, телешко, халапеньо, чедър и гъби',
  'Сицилиана': 'Сицилиана',
  'Доматен сос, моцарела, пилешко филе, сушени домати, топени сирене и песто': 'Доматен сос, моцарела, пилешко филе, сушени домати, топени сирене и песто',
  'Калцоне': 'Калцоне',
  'Доматен сос, моцарела, шунка, гъби, кисели краствички': 'Доматен сос, моцарела, шунка, гъби, кисели краствички',
  'средна - 30 см': 'средна - 30 см',
  'голяма - 50 см': 'голяма - 50 см',
  'Ница Бургер': 'Ница Бургер',
  'Питка бриош, айсберг, домат, телешко, чедър, яйце, бекон, карамелизиран лук и ница сос': 'Питка бриош, айсберг, домат, телешко, чедър, яйце, бекон, карамелизиран лук и ница сос',
  'Класик Бургер': 'Класик Бургер',
  'Питка бриош, айсберг, кисели краставички, телешко, ница сос': 'Питка бриош, айсберг, кисели краставички, телешко, ница сос',
  'Чийз Бургер': 'Чийз Бургер',
  'Питка бриош, айсберг, кисели краставици, домат, телешко, чедър, червен лук и ница сос': 'Питка бриош, айсберг, кисели краставици, домат, телешко, чедър, червен лук и ница сос',
  'Пилешки Бургер': 'Пилешки Бургер',
  'Питка бриош, рукола, сушени домати, гриловано пилешко, червен лук, ементал и домашна майонеза': 'Питка бриош, рукола, сушени домати, гриловано пилешко, червен лук, ементал и домашна майонеза',
  'Криспи Чикън Бургер': 'Криспи Чикън Бургер',
  'Питка бриош, айсберг, кисели краставици, хрупкаво, панирано пилешко филе, бекон и японска майонеза': 'Питка бриош, айсберг, кисели краставици, хрупкаво, панирано пилешко филе, бекон и японска майонеза',
  'Смоуки Бургер': 'Смоуки Бургер',
  'Питка бриош, айсберг, телешко, бекон, лучени кръгчета, моцарела и ница сос': 'Питка бриош, айсберг, телешко, бекон, лучени кръгчета, моцарела и ница сос',
  'Пулд Порк Бургер': 'Пулд Порк Бургер',
  'Питка бриош, айсберг, кисели краставици, бавно готвено свинско месо, чедър, карамелизиран лук и барбекю сос': 'Питка бриош, айсберг, кисели краставици, бавно готвено свинско месо, чедър, карамелизиран лук и барбекю сос',
  'Спайси Найси Бургер': 'Спайси Найси Бургер',
  'Питка бриош, телешко, айсберг, чедър, халапеньо, доматено пикантно чътни и ница сос': 'Питка бриош, телешко, айсберг, чедър, халапеньо, доматено пикантно чътни и ница сос',
  'Веджи Бургер': 'Веджи Бургер',
  'Бургер от киноа и халуми, айсберг, чедър, домат, кисели краставички, червен лук': 'Бургер от киноа и халуми, айсберг, чедър, домат, кисели краставички, червен лук',
  'Детски Бургер (МЕНЮ)': 'Детски Бургер (МЕНЮ)',
  'Питка бриош, телешко, чедър, домат, кисели краставички и майонеза + пържени картофки и плодов сок': 'Питка бриош, телешко, чедър, домат, кисели краставички и майонеза + пържени картофки и плодов сок',
  'Лучени кръгчета': 'Лучени кръгчета',
  '200 гр': '200 гр',
  'Пържени картофи': 'Пържени картофи',
  'Хрупкави пилешки филенца': 'Хрупкави пилешки филенца',
  'хрупкави панирани пилешки филенца с чеснов сос': 'хрупкави панирани пилешки филенца с чеснов сос',
  'Порция с хрупкаво пиле': 'Порция с хрупкаво пиле',
  'Панирано филе, басмати ориз, микс салатки': 'Панирано филе, басмати ориз, микс салатки',
  'Порция пилешко филе': 'Порция пилешко филе',
  'Пилешко филе, басмати ориз, микс салатки  ': 'Пилешко филе, басмати ориз, микс салатки  ',
  'Порция телешко': 'Порция телешко',
  '2бр. телешки кюфтенца, басмати ориз, микс салатки': '2бр. телешки кюфтенца, басмати ориз, микс салатки',
  'Порция веджи': 'Порция веджи',
  'Кюфтенце от киноа, басмати ориз, микс салатки': 'Кюфтенце от киноа, басмати ориз, микс салатки',
  'Ницета с пеперони': 'Ницета с пеперони',
  'Пеперони, моцарела и масло': 'Пеперони, моцарела и масло',
  'Ницета с шунка': 'Ницета с шунка',
  'Шунка, моцарела и масло': 'Шунка, моцарела и масло',
  'Ницета с пилешко филе': 'Ницета с пилешко филе',
  'Пилешко филе, моцарела и масло': 'Пилешко филе, моцарела и масло',
  'Ницета с бекон': 'Ницета с бекон',
  'Бекон, моцарела и масло': 'Бекон, моцарела и масло',
  'Тортиля НИЦА': 'Тортиля НИЦА',
  'Мляно свинско – телешко месо,айсберг, домат, кисела краставичка,моцарела,карамелизиран лук,картофки,ница сос': 'Мляно свинско – телешко месо,айсберг, домат, кисела краставичка,моцарела,карамелизиран лук,картофки,ница сос',
  'Тортиля с пилешко': 'Тортиля с пилешко',
  'Пилешко филе,моцарела, рукола, сушени домати, червен лук, картофки, домашна майонеза': 'Пилешко филе,моцарела, рукола, сушени домати, червен лук, картофки, домашна майонеза',
  'Тортиля със свинско': 'Тортиля със свинско',
  'Бавно готвено свинско, айсберг, кисели краставички,айсберг,карамелизиран лук, картофки, моцарела,BBQ сос': 'Бавно готвено свинско, айсберг, кисели краставички,айсберг,карамелизиран лук, картофки, моцарела,BBQ сос',
  'Тортиля с хрупкаво пиле': 'Тортиля с хрупкаво пиле',
  'Хрупкаво панирано пилешко, айсберг, кисели краставички, домат,  моцарела, картофки, чеснов сос': 'Хрупкаво панирано пилешко, айсберг, кисели краставички, домат,  моцарела, картофки, чеснов сос',
  'Джоб Ница': 'Джоб Ница',
  'Телешко, айсберг, домати, кисели краставички ,моцарела, карамелизиран лук, картофи , ница сос': 'Телешко, айсберг, домати, кисели краставички ,моцарела, карамелизиран лук, картофи , ница сос',
  'Джоб Пулд порк': 'Джоб Пулд порк',
  'Бавно готвено свинско, айсберг, кисели краставички, червен лук, чедър, картофи, BBQ сос': 'Бавно готвено свинско, айсберг, кисели краставички, червен лук, чедър, картофи, BBQ сос',
  'Джоб Чийз BBQ бекон': 'Джоб Чийз BBQ бекон',
  'Хрупков бекон, чедър, айсберг, домат, червен лук, картофи, BBQ сос': 'Хрупков бекон, чедър, айсберг, домат, червен лук, картофи, BBQ сос',
  'Джоб Поло': 'Джоб Поло',
  'Пилешка шунка, моцарела, айсберг, домат, картофи, чеснов сос': 'Пилешка шунка, моцарела, айсберг, домат, картофи, чеснов сос',
  'Джоб Вегетериански': 'Джоб Вегетериански',
  'Моцарела, чедър, топено сирене, яйце, картофи, айсберг, домат, ница сос': 'Моцарела, чедър, топено сирене, яйце, картофи, айсберг, домат, ница сос',
  'Джоб Капризен': 'Джоб Капризен',
  'Прошуто кото, айсберг, домат, зелена чушка, моцарела, каротфи, майонеза': 'Прошуто кото, айсберг, домат, зелена чушка, моцарела, каротфи, майонеза',
  'Джоб сандвич Мексикански': 'Джоб сандвич Мексикански',
  'Телешко, домати, айсберг, царевица, халапеньо, червен лук, картофи, чили сос': 'Телешко, домати, айсберг, царевица, халапеньо, червен лук, картофи, чили сос',
  'Салата Цезар': 'Салата Цезар',
  'Айсберг, сос Цезар, пилешки филенца, чери домати, бекон, кротони и пармезан - 350 гр': 'Айсберг, сос Цезар, пилешки филенца, чери домати, бекон, кротони и пармезан - 350 гр',
  'Айсберг с рукола': 'Айсберг с рукола',
  'Айсберг, рукола, чери домати, сос Винегрет, пармезан - 250 гр': 'Айсберг, рукола, чери домати, сос Винегрет, пармезан - 250 гр',
  'Домати с печена чушка': 'Домати с печена чушка',
  'Белени домати, печени чушки, маслина, сирене, зехтин 400гр': 'Белени домати, печени чушки, маслина, сирене, зехтин 400гр',
  'Капрезе': 'Капрезе',
  'Домати, свежа моцарела, песто, рукола и пармезан - 400 гр': 'Домати, свежа моцарела, песто, рукола и пармезан - 400 гр',
  'Салата Кобб': 'Салата Кобб',
  'Айсберг, пилешко филе, сушени домати, авокадо, бекон, синьо сирене и лимонов дресинг - 350 гр': 'Айсберг, пилешко филе, сушени домати, авокадо, бекон, синьо сирене и лимонов дресинг - 350 гр',
  'Салата хрупкаво пиле': 'Салата хрупкаво пиле',
  'Айсбег, домат, царевица, панирано пиле, чеснов сос, пармезан': 'Айсбег, домат, царевица, панирано пиле, чеснов сос, пармезан',
  'Шоколадова кариолка': 'Шоколадова кариолка',
  'Шоколад , масло , ядки - 70 гр. / бр': 'Шоколад , масло , ядки - 70 гр. / бр',
  'Крем Ден и нощ': 'Крем Ден и нощ',
  'масло, сметана, шоколад, пандишпан, ядки - 160 гр. / бр': 'масло, сметана, шоколад, пандишпан, ядки - 160 гр. / бр',
  'Кока кола – 330ml': 'Кока кола – 330ml',
  '': '',
  'Фанта Портокал – 330ml': 'Фанта Портокал – 330ml',
  'Спрайт – 330ml': 'Спрайт – 330ml',
  'Кока кола – 500мл': 'Кока кола – 500мл',
  'Фанта Портокал – 500мл': 'Фанта Портокал – 500мл',
  'Спрайт – 500мл': 'Спрайт – 500мл',
  'Фанта Лимон – 500мл': 'Фанта Лимон – 500мл',
  'Кока кола – 2L': 'Кока кола – 2L',
  'Фанта Портокал – 2L': 'Фанта Портокал – 2L',
  'Нестий праскова – 500ml': 'Нестий праскова – 500ml',
  'Нестий лимон – 500ml': 'Нестий лимон – 500ml',
  'Нестий горски плод – 500ml': 'Нестий горски плод – 500ml',
  'Нестий манго и ананас – 500ml': 'Нестий манго и ананас – 500ml',
  'Минерална вода – 500ml': 'Минерална вода – 500ml',
  'Минерална вода – 1,5L': 'Минерална вода – 1,5L',
  'Айран – 330ml': 'Айран – 330ml',
  'Загорка кен – 500ml': 'Загорка кен – 500ml',
  'Хайникен кен – 500ml': 'Хайникен кен – 500ml',
  'Хайнекен 330': 'Хайнекен 330',
  'Кетчуп': 'Кетчуп',
  '50 гр': '50 гр',
  'Майонеза': 'Майонеза',
  'Горчица': 'Горчица',
  'Чили сос': 'Чили сос',
  'Чеснов сос': 'Чеснов сос',
  'Барбекю': 'Барбекю',
  'Сладко чили': 'Сладко чили',
  'Цезар': 'Цезар',
  'Песто': 'Песто',
  'Ница сос': 'Ница сос'
    
    },
  bg: {
    "Поръчай тук": "Поръчай тук",
    "Кафе Верняно": "Кафе Верняно",
    "Кафе Верняно - промо 10:00": "Кафе Верняно - промо 10:00",
    Фреш: "Фреш",
    "Кафе Верняно - 100% Арабика": "Кафе Верняно - 100% Арабика",
    "Кафе Верняно - Безкофеиново": "Кафе Верняно - Безкофеиново",
    Банкя: "Банкя",
    "Кока-Кола": "Кока-Кола",
    Капи: "Капи",
    Швепс: "Швепс",
    Спрайт: "Спрайт",
    "Студен чай": "Студен Чай",
    Чай: "Чай",
    Сода: "Сода",
    Фрапе: "Фрапе",
    "3в1": "3 в 1",
    Лате: "Лате",
    Лимонада: "Лимонада",
    Нескафе: "Нескафе",
    "Капучино Верняно": "Капучино Верняно",
    "Мляко с какао Верняно": "Мляко с какао Верняно",
    "Топъл Шоколад Верняно": "Топъл Шоколад Верняно",
    "Външна батерия": "Външна батерия",
    Цитронада: "Цитронада",
    Самърсби: "Самърсби",
    "Банкя - стъклена бутилка": "Банкя - стъклена бутилка",
    Корона: "Корона",
    "Jack Daniel's Honey Lemonade": "Jack Daniel's Honey Lemonade",
    "Bickens Pink & Pink Tonic Style": "Bickens Pink & Pink Tonic Style",
    "Bacardi Mojito": "Бакарди Мохито",
    Шот: "Шот",
    Шейкър: "Шейкър",
    Фанта: "Фанта",
    Загорка: "Загорка",
    "Хайникен наливна": "Хайникен наливна",
    Шприц: "Шприц",
    Аперол: "Аперол",
    Лимончело: "Limoncello",
    Маркати: "Marcati",
    Мартини: "Мартини",
    Бианко: "Бианко",
    Кампари: "Кампари",
    Бакарди: "Бакарди",
    Ликьор: "Ликьор",
    Дисароно: "Дисаронно",
    Бушмилс: "Бушмилс",
    Джони: "Джони",
    Джеймсън: "Джеймсън",
    "J&B": "J&B",
    "Джак Даниелс": "Джак Даниелс",
    "Сингъл Барел": "Сингъл Барел",
    Житная: "Житная",
    Абсолют: "Абсолют",
    "Руски Стандарт": "Руски Стандарт",
    Финландия: "Финландия",
    Бифитър: "Бифитър",
    Горданс: "Горданс",
    "Горданс Пинк": "Горданс Пинк",
    Джин: "Джин",
    Бомбай: "Бомбай",
    Узо: "Узо",
    12: "12",
    7: "7",
    Пломари: "Пломари",
    Тсантали: "Тсантали",
    "Чивас Регал": "Чивас Регал",
    Кардю: "Кардю",
    "Джентълмен Джак": "Джентълмен Джак",
    Гленфидиш: "Гленфидиш",
    РедБул: "РедБул",
    "Сайкъл Сов Блан": "Сайкъл Сов. Блан",
    Столично: "Столично",
    Хайникен: "Хайникен",
    Ариана: "Ариана",
    Старобърно: "Старобърно",
    Ботега: "Ботега",
    Морети: "Морети",
    "Афтър Шок": "Афтър Шок",
    Савой: "Савой",
    "Зельоная Марка": "Зельоная Марка",
    Столичная: "Столичная",
    Търговище: "Търговище",
    "Грей Гус": "Грей Гус",
    Белуга: "Белуга",
    "Бургас 63": "Бургас 63",
    "Бургаска Мускатова": "Бургаска Мускатова",
    "Кайлъшка гроздова": "Кайлъшка гроздова",
    Карнобатска: "Карнобатска",
    Пещерска: "Пещерска",
    "Плиска Преслав": "Плиска Преслав",
    "Мента Пещера": "Мента Пещера",
    "Къти Сарк": "Къти Сарк",
    "Джийм Бийм": "Джим Бийм",
    "Джак Даниелс": "Джак",
    Грантс: "Грантс",
    Метакса: "Метакса",
    "Сайкъл Траминер": "Сайкъл Траминер",
    "Сайкъл Мерло и Пино Ноар": "Сайкъл Мерло и Пино Ноар",
    "Сайкъл Розе": "Сайкъл Розе",
    "Едоардо Миролио Совиньон Блан": "Едоардо Миролио Совиньон Блан",
    "JP Chenet - 250 мл": "JP. Chenet - 250 мл.",
    "Моет Шандон Брут": "Moët & Chandon Impérial Brut",
    Напитки: "Напитки",
    Коктейли: "Коктейли",
    "Друг алкохол": "Друг алкохол",

    Кафетерия: "Кафетерия",
    Топли: "Топли",
    Фрешове: "Фрешове",
    късо: "късо",
    нормално: "нормално",
    дълго: "дълго",
    лв: "лв.",
    "25 мл": "25 мл.",
    "300 мл": "300 мл.",
    "50 мл": "50 мл.",
    "100 мл": "100 мл.",
    "200 мл": "200 мл.",
    "250 мл": "250 мл.",
    "330 мл": "330 мл.",
    "350 мл": "350 мл.",
    "355 мл": "355 мл.",
    "375 мл": "375 мл.",
    "250 мл": "250 мл.",
    "500 мл": "500 мл.",
    "750 мл": "750 мл.",
    Безалкохолни: "Безалкохолни",
    Бири: "Бири",
    Водка: "Водка",
    Уиски: "Уиски",
    "без захар": "без захар",
    "с лимон": "с лимон",
    портокал: "портокал",
    праскова: "праскова",
    кайсия: "кайсия",
    ананас: "ананас",
    мандарина: "мандарина",
    тоник: "тоник",
    лимон: "лимон",
    нар: "нар",
    зелен: "зелен",
    "горски плодове": "горски плодове",
    бяло: "бяло",
    черно: "черно",
    "-": "-",
    ягода: "ягода",
    "лайм-джинджър": "лайм-джинджър",
    мента: "мента",
    топло: "топло",
    студено: "студено",
    черен: "черен",
    бял: "бял",
    "с кокос": "с кокос",
    лате: "лате",
    "Micro USB": "Micro USB",
    "USB C": "USB C",
    iPhone: "iPhone",
    Боровинка: "боровинка",
    Ябълка: "ябълка",
    Круша: "круша",
    Манго: "манго",
    грейпфрут: "грейпфрут",
    микс: "микс",
    малко: "малко",
    червено: "червено",
    малка: "малка",
    "12 годишно": "12 годишно",
    боквайс: "боквайс",
    вайс: "вайс",
    традиционна: "традиционна",
    розе: "розе",
    "Additional comment:": "Забележки:",
    "Table closed": "Масата е затворена",
    "This table is already closed. Please ask staff to open a new table.": "Тази маса вече е затворена. Моля, помолете персонала да отвори нова маса.",
    "Failed to add item to table": "Неуспешно добавяне на артикула към масата",

    // Landing page
    "Harlem": "Harlem",
    "Harlem by Refraction X": "Harlem by Refraction X",
    "Food, drinks, gaming": "Храна, напитки, игри",
    "Order from the bar, check the menu, or jump into the venue app.": "Поръчайте от бара, разгледайте менюто или влезте в приложението на обекта.",
    "Burger Nizza": "Burger Nizza",
    "Burgers, sides, delivery": "Бургери, гарнитури, доставка",
    "Order online, check the menu, or choose pickup and delivery.": "Поръчайте онлайн, разгледайте менюто или изберете вземане и доставка.",
    "Order, pickup, delivery": "Поръчка, вземане, доставка",
    "Order online, check the menu, or continue into the venue app.": "Поръчайте онлайн, разгледайте менюто или продължете към приложението на обекта.",
    "Order now": "Поръчай сега",
    "Online orders": "Онлайн поръчки",
    "Pickup or delivery": "Вземане или доставка",
    "Menu": "Меню",
    "Food and drinks": "Храна и напитки",
    "E-sports": "E-sports",
    "PC stations": "PC станции",
    "VR": "VR",
    "Virtual reality": "Виртуална реалност",
    "Featured": "Избрани",
    "Ready when you are": "Готови сме",
    "Start order": "Започни поръчка",
    "Operator": "Оператор",

    // Category and Product Management
    "Categories": "Категории",
    "Create New Category": "Създай нова категория",
    "Category ID (e.g., burgers)": "ID на категория (напр., burgers)",
    "Category Name": "Име на категория",
    "Order": "Ред",
    "Name": "Име",
    "Create Category": "Създай категория",
    "Category created successfully": "Категорията е създадена успешно",
    "Category updated successfully": "Категорията е обновена успешно",
    "Category deleted successfully": "Категорията е изтрита успешно",
    "Failed to create category": "Неуспешно създаване на категория",
    "Failed to update category": "Неуспешно обновяване на категория",
    "Failed to delete category": "Неуспешно изтриване на категория",
    "Please enter both category ID and name": "Моля, въведете ID и име на категорията",
    "Delete Category": "Изтрий категория",
    "Error loading categories": "Грешка при зареждане на категориите",
    
    "Products": "Продукти",
    "New Product": "Нов продукт",
    "Edit Product": "Редактирай продукт",
    "Create New Product": "Създай нов продукт",
    "Update Product": "Обнови продукт",
    "Create Product": "Създай продукт",
    "Delete Product": "Изтрий продукт",
    "Product ID (e.g., burger-classic)": "ID на продукт (напр., burger-classic)",
    "Title *": "Заглавие *",
    "Subtitle": "Подзаглавие",
    "Variants, Volumes & Prices": "Варианти, обеми и цени",
    "Variant": "Вариант",
    "Volume": "Обем",
    "Price": "Цена",
    "Add Variant": "Добави вариант",
    "Variant %d (e.g., Small)": "Вариант %d (напр., Малък)",
    "Volume (e.g., 250ml)": "Обем (напр., 250ml)",
    "Each variant must have a volume and price": "Всеки вариант трябва да има обем и цена",
    "Order (optional)": "Ред (незадължително)",
    "Published:": "Публикуван:",
    "Available:": "Наличен:",
    "Yes": "Да",
    "No": "Не",
    "Product Options (optional)": "Опции на продукт (незадължително)",
    "Add Option": "Добави опция",
    "Option %d": "Опция %d",
    "Option Title (e.g., Choose Size)": "Заглавие на опция (напр., Изберете размер)",
    "Type:": "Тип:",
    "Conf (single)": "Конф (единичен избор)",
    "Add (multiple)": "Добавка (множество)",
    "Required:": "Задължително:",
    "Choices": "Избори",
    "Add Choice": "Добави избор",
    "Choice %d (e.g., Large)": "Избор %d (напр., Голям)",
    "Prices per variant (additional cost):": "Цени за вариант (допълнителна цена):",
    "Product created successfully": "Продуктът е създаден успешно",
    "Product updated successfully": "Продуктът е обновен успешно",
    "Product deleted successfully": "Продуктът е изтрит успешно",
    "Failed to create product": "Неуспешно създаване на продукт",
    "Failed to update product": "Неуспешно обновяване на продукт",
    "Failed to delete product": "Неуспешно изтриване на продукт",
    "Please fill in required fields (ID, Category, Title)": "Моля, попълнете задължителните полета (ID, Категория, Заглавие)",
    "At least one variant is required": "Изисква се поне един вариант",
    "Number of prices must match number of variants": "Броят цени трябва да съответства на броя варианти",
    "Number of volumes must match number of variants": "Броят обеми трябва да съответства на броя варианти",
    "Must have at least one variant": "Трябва да има поне един вариант",
    "Filter by Category:": "Филтър по категория:",
    "All Categories": "Всички категории",
    "Published": "Публикуван",
    "Unpublished": "Непубликуван",
    "Available": "Наличен",
    "Unavailable": "Неналичен",
    "Variants:": "Варианти:",
    "Volumes:": "Обеми:",
    "Prices:": "Цени:",
    "Options:": "Опции:",
    "Upload Image": "Качи изображение",
    "Delete Image": "Изтрий изображение",
    "Image uploaded successfully": "Изображението е качено успешно",
    "Image deleted successfully": "Изображението е изтрито успешно",
    "Failed to upload image": "Неуспешно качване на изображение",
    "Failed to delete image": "Неуспешно изтриване на изображение",
    "Permission Required": "Необходимо разрешение",
    "Permission to access media library is required!": "Необходимо е разрешение за достъп до медийната библиотека!",
    "Are you sure you want to delete this image?": "Сигурни ли сте, че искате да изтриете това изображение?",
    "Are you sure you want to delete": "Сигурни ли сте, че искате да изтриете",
    "Options are extras/customizations like size, toppings, etc. Each choice has prices per variant.": "Опциите са допълнения/персонализации като размер, добавки и др. Всеки избор има цени за вариант.",
    "No options added. Options allow customers to customize their order (e.g., size, toppings).": "Няма добавени опции. Опциите позволяват на клиентите да персонализират поръчката си (напр., размер, добавки).",

    // Nizza
        средна: "средна",
    голяма: "голяма",
    Пица: "Пица",
    Бургери: "Бургери",
    Гарнитури: "Гарнитури",
    Десерти: "Десерти",
    Сосове: "Сосове",
    Порции: "Порции",
    Сандвичи: "Сандвичи",
    Салати: "Салати",
    "From:": "От:",
    "City:": "Град:",
    "Street:": "Улица:",
    "Comment:": "Коментар:",
    Deliveries: "Доставки",
    Delivery: "Доставка",
    "Phone:": "Тел:",
    Добавка: "Добавка",
    Тесто: "Тесто",
    "Сусамово семе": "Сусамово семе",
    "Слънчогледово семе": "Слънчогледово семе",
    "Ленено семе": "Ленено семе",
    "Маково семе": "Маково семе",
    Борд: "Борд",
    Моцарела: "Моцарела",
    Чеснов: "Чеснов",
    Чедър: "Чедър",
    Филаделфия: "Филаделфия",
    "": "",


  'Маргарита': 'Маргарита',
  'Доматен сос и моцарела': 'Доматен сос и моцарела',
  'малка - 26 см': 'малка - 26 см',
  'Пресни домати': 'Пресни домати',
  'Чери домати': 'Чери домати',
  'Кисели краставички': 'Кисели краставички',
  'Сушени домати': 'Сушени домати',
  'Карамелизиран Лук': 'Карамелизиран Лук',
  'Халапеньо': 'Халапеньо',
  'Авокадо': 'Авокадо',
  'Свинска шунка': 'Свинска шунка',
  'Бекон': 'Бекон',
  'Пилешка шунка': 'Пилешка шунка',
  'Луканков салам': 'Луканков салам',
  'Прошуто': 'Прошуто',
  'Пеперони': 'Пеперони',
  'Кюфте': 'Кюфте',
  'Свинско Конци': 'Свинско Конци',
  'Пилешко филе': 'Пилешко филе',
  'Доматен сос': 'Доматен сос',
  'Сметана': 'Сметана',
  'Моцарела': 'Моцарела',
  'Синьо сирене': 'Синьо сирене',
  'Пармезан': 'Пармезан',
  'Бяло сирене': 'Бяло сирене',
  'Пушено сирене': 'Пушено сирене',
  'Яйце': 'Яйце',
  'Рукола': 'Рукола',
  'Айсберг': 'Айсберг',
  'Зелена чушка': 'Зелена чушка',
  'Гъби': 'Гъби',
  'Царевица': 'Царевица',
  'Червен лук': 'Червен лук',
  'Маслини': 'Маслини',
  'Люта чушка': 'Люта чушка',
  'Куатро Формаджи': 'Куатро Формаджи',
  'Доматен сос, моцарела, синьо сирене, чедър и топено сирене': 'Доматен сос, моцарела, синьо сирене, чедър и топено сирене',
  'Куатро Ди Карне': 'Куатро Ди Карне',
  'Доматен сос, моцарела, шунка, пилешко филе, бекон и луканов салам': 'Доматен сос, моцарела, шунка, пилешко филе, бекон и луканов салам',
  'Капричоза': 'Капричоза',
  'Доматен сос, моцарела, шунка, гъби и чушки': 'Доматен сос, моцарела, шунка, гъби и чушки',
  'Поло': 'Поло',
  'Доматен сос, моцарела, пилешко филе, гъби и чушки': 'Доматен сос, моцарела, пилешко филе, гъби и чушки',
  'Карбонара': 'Карбонара',
  'Сметанов сос, моцарела, бекон, гъби и пармезан': 'Сметанов сос, моцарела, бекон, гъби и пармезан',
  'Ница': 'Ница',
  'Доматен сос, моцарела, шунка, бекон, гъби и сметана': 'Доматен сос, моцарела, шунка, бекон, гъби и сметана',
  'Диаволо': 'Диаволо',
  'Доматен сос, моцарела, шунка, пеперони, люта чушка и чери домати': 'Доматен сос, моцарела, шунка, пеперони, люта чушка и чери домати',
  'Американо BBQ': 'Американо BBQ',
  'Доматен сос, BBQ сос, горчица, моцарела, пилешко филе, пеперони, чушки и маслини': 'Доматен сос, BBQ сос, горчица, моцарела, пилешко филе, пеперони, чушки и маслини',
  'Алфредо': 'Алфредо',
  'Сметанов сос, моцарела, пилешко филе, царевица и топено сирене': 'Сметанов сос, моцарела, пилешко филе, царевица и топено сирене',
  'Доматен сос, моцарела и пеперони': 'Доматен сос, моцарела и пеперони',
  'Мексикана': 'Мексикана',
  'Доматен сос, моцарела, пеперони, червен лук, маслини, царевица, люта чушка': 'Доматен сос, моцарела, пеперони, червен лук, маслини, царевица, люта чушка',
  'Италия': 'Италия',
  'Доматен сос, моцарела, сушени домати, пармезан и песто': 'Доматен сос, моцарела, сушени домати, пармезан и песто',
  'Салами': 'Салами',
  'Доматен сос, моцарела, луканков салам, чушка и маслини': 'Доматен сос, моцарела, луканков салам, чушка и маслини',
  'Вегетариана': 'Вегетариана',
  'Доматен сос, моцарела, гъби, царевица, чушка, червен лук и маслини': 'Доматен сос, моцарела, гъби, царевица, чушка, червен лук и маслини',
  'Прошуто фунги': 'Прошуто фунги',
  'Доматен сос, моцарела, прошуто крудо, гъби, рукола и пармезан': 'Доматен сос, моцарела, прошуто крудо, гъби, рукола и пармезан',
  'Бургер Пица': 'Бургер Пица',
  'Доматен сос, моцарела, телешко, халапеньо, чедър и гъби': 'Доматен сос, моцарела, телешко, халапеньо, чедър и гъби',
  'Сицилиана': 'Сицилиана',
  'Доматен сос, моцарела, пилешко филе, сушени домати, топени сирене и песто': 'Доматен сос, моцарела, пилешко филе, сушени домати, топени сирене и песто',
  'Калцоне': 'Калцоне',
  'Доматен сос, моцарела, шунка, гъби, кисели краствички': 'Доматен сос, моцарела, шунка, гъби, кисели краствички',
  'средна - 30 см': 'средна - 30 см',
  'голяма - 50 см': 'голяма - 50 см',
  'Ница Бургер': 'Ница Бургер',
  'Питка бриош, айсберг, домат, телешко, чедър, яйце, бекон, карамелизиран лук и ница сос': 'Питка бриош, айсберг, домат, телешко, чедър, яйце, бекон, карамелизиран лук и ница сос',
  'Класик Бургер': 'Класик Бургер',
  'Питка бриош, айсберг, кисели краставички, телешко, ница сос': 'Питка бриош, айсберг, кисели краставички, телешко, ница сос',
  'Чийз Бургер': 'Чийз Бургер',
  'Питка бриош, айсберг, кисели краставици, домат, телешко, чедър, червен лук и ница сос': 'Питка бриош, айсберг, кисели краставици, домат, телешко, чедър, червен лук и ница сос',
  'Пилешки Бургер': 'Пилешки Бургер',
  'Питка бриош, рукола, сушени домати, гриловано пилешко, червен лук, ементал и домашна майонеза': 'Питка бриош, рукола, сушени домати, гриловано пилешко, червен лук, ементал и домашна майонеза',
  'Криспи Чикън Бургер': 'Криспи Чикън Бургер',
  'Питка бриош, айсберг, кисели краставици, хрупкаво, панирано пилешко филе, бекон и японска майонеза': 'Питка бриош, айсберг, кисели краставици, хрупкаво, панирано пилешко филе, бекон и японска майонеза',
  'Смоуки Бургер': 'Смоуки Бургер',
  'Питка бриош, айсберг, телешко, бекон, лучени кръгчета, моцарела и ница сос': 'Питка бриош, айсберг, телешко, бекон, лучени кръгчета, моцарела и ница сос',
  'Пулд Порк Бургер': 'Пулд Порк Бургер',
  'Питка бриош, айсберг, кисели краставици, бавно готвено свинско месо, чедър, карамелизиран лук и барбекю сос': 'Питка бриош, айсберг, кисели краставици, бавно готвено свинско месо, чедър, карамелизиран лук и барбекю сос',
  'Спайси Найси Бургер': 'Спайси Найси Бургер',
  'Питка бриош, телешко, айсберг, чедър, халапеньо, доматено пикантно чътни и ница сос': 'Питка бриош, телешко, айсберг, чедър, халапеньо, доматено пикантно чътни и ница сос',
  'Веджи Бургер': 'Веджи Бургер',
  'Бургер от киноа и халуми, айсберг, чедър, домат, кисели краставички, червен лук': 'Бургер от киноа и халуми, айсберг, чедър, домат, кисели краставички, червен лук',
  'Детски Бургер (МЕНЮ)': 'Детски Бургер (МЕНЮ)',
  'Питка бриош, телешко, чедър, домат, кисели краставички и майонеза + пържени картофки и плодов сок': 'Питка бриош, телешко, чедър, домат, кисели краставички и майонеза + пържени картофки и плодов сок',
  'Лучени кръгчета': 'Лучени кръгчета',
  '200 гр': '200 гр',
  'Пържени картофи': 'Пържени картофи',
  'Хрупкави пилешки филенца': 'Хрупкави пилешки филенца',
  'хрупкави панирани пилешки филенца с чеснов сос': 'хрупкави панирани пилешки филенца с чеснов сос',
  'Порция с хрупкаво пиле': 'Порция с хрупкаво пиле',
  'Панирано филе, басмати ориз, микс салатки': 'Панирано филе, басмати ориз, микс салатки',
  'Порция пилешко филе': 'Порция пилешко филе',
  'Пилешко филе, басмати ориз, микс салатки  ': 'Пилешко филе, басмати ориз, микс салатки  ',
  'Порция телешко': 'Порция телешко',
  '2бр. телешки кюфтенца, басмати ориз, микс салатки': '2бр. телешки кюфтенца, басмати ориз, микс салатки',
  'Порция веджи': 'Порция веджи',
  'Кюфтенце от киноа, басмати ориз, микс салатки': 'Кюфтенце от киноа, басмати ориз, микс салатки',
  'Ницета с пеперони': 'Ницета с пеперони',
  'Пеперони, моцарела и масло': 'Пеперони, моцарела и масло',
  'Ницета с шунка': 'Ницета с шунка',
  'Шунка, моцарела и масло': 'Шунка, моцарела и масло',
  'Ницета с пилешко филе': 'Ницета с пилешко филе',
  'Пилешко филе, моцарела и масло': 'Пилешко филе, моцарела и масло',
  'Ницета с бекон': 'Ницета с бекон',
  'Бекон, моцарела и масло': 'Бекон, моцарела и масло',
  'Тортиля НИЦА': 'Тортиля НИЦА',
  'Мляно свинско – телешко месо,айсберг, домат, кисела краставичка,моцарела,карамелизиран лук,картофки,ница сос': 'Мляно свинско – телешко месо,айсберг, домат, кисела краставичка,моцарела,карамелизиран лук,картофки,ница сос',
  'Тортиля с пилешко': 'Тортиля с пилешко',
  'Пилешко филе,моцарела, рукола, сушени домати, червен лук, картофки, домашна майонеза': 'Пилешко филе,моцарела, рукола, сушени домати, червен лук, картофки, домашна майонеза',
  'Тортиля със свинско': 'Тортиля със свинско',
  'Бавно готвено свинско, айсберг, кисели краставички,айсберг,карамелизиран лук, картофки, моцарела,BBQ сос': 'Бавно готвено свинско, айсберг, кисели краставички,айсберг,карамелизиран лук, картофки, моцарела,BBQ сос',
  'Тортиля с хрупкаво пиле': 'Тортиля с хрупкаво пиле',
  'Хрупкаво панирано пилешко, айсберг, кисели краставички, домат,  моцарела, картофки, чеснов сос': 'Хрупкаво панирано пилешко, айсберг, кисели краставички, домат,  моцарела, картофки, чеснов сос',
  'Джоб Ница': 'Джоб Ница',
  'Телешко, айсберг, домати, кисели краставички ,моцарела, карамелизиран лук, картофи , ница сос': 'Телешко, айсберг, домати, кисели краставички ,моцарела, карамелизиран лук, картофи , ница сос',
  'Джоб Пулд порк': 'Джоб Пулд порк',
  'Бавно готвено свинско, айсберг, кисели краставички, червен лук, чедър, картофи, BBQ сос': 'Бавно готвено свинско, айсберг, кисели краставички, червен лук, чедър, картофи, BBQ сос',
  'Джоб Чийз BBQ бекон': 'Джоб Чийз BBQ бекон',
  'Хрупков бекон, чедър, айсберг, домат, червен лук, картофи, BBQ сос': 'Хрупков бекон, чедър, айсберг, домат, червен лук, картофи, BBQ сос',
  'Джоб Поло': 'Джоб Поло',
  'Пилешка шунка, моцарела, айсберг, домат, картофи, чеснов сос': 'Пилешка шунка, моцарела, айсберг, домат, картофи, чеснов сос',
  'Джоб Вегетериански': 'Джоб Вегетериански',
  'Моцарела, чедър, топено сирене, яйце, картофи, айсберг, домат, ница сос': 'Моцарела, чедър, топено сирене, яйце, картофи, айсберг, домат, ница сос',
  'Джоб Капризен': 'Джоб Капризен',
  'Прошуто кото, айсберг, домат, зелена чушка, моцарела, каротфи, майонеза': 'Прошуто кото, айсберг, домат, зелена чушка, моцарела, каротфи, майонеза',
  'Джоб сандвич Мексикански': 'Джоб сандвич Мексикански',
  'Телешко, домати, айсберг, царевица, халапеньо, червен лук, картофи, чили сос': 'Телешко, домати, айсберг, царевица, халапеньо, червен лук, картофи, чили сос',
  'Салата Цезар': 'Салата Цезар',
  'Айсберг, сос Цезар, пилешки филенца, чери домати, бекон, кротони и пармезан - 350 гр': 'Айсберг, сос Цезар, пилешки филенца, чери домати, бекон, кротони и пармезан - 350 гр',
  'Айсберг с рукола': 'Айсберг с рукола',
  'Айсберг, рукола, чери домати, сос Винегрет, пармезан - 250 гр': 'Айсберг, рукола, чери домати, сос Винегрет, пармезан - 250 гр',
  'Домати с печена чушка': 'Домати с печена чушка',
  'Белени домати, печени чушки, маслина, сирене, зехтин 400гр': 'Белени домати, печени чушки, маслина, сирене, зехтин 400гр',
  'Капрезе': 'Капрезе',
  'Домати, свежа моцарела, песто, рукола и пармезан - 400 гр': 'Домати, свежа моцарела, песто, рукола и пармезан - 400 гр',
  'Салата Кобб': 'Салата Кобб',
  'Айсберг, пилешко филе, сушени домати, авокадо, бекон, синьо сирене и лимонов дресинг - 350 гр': 'Айсберг, пилешко филе, сушени домати, авокадо, бекон, синьо сирене и лимонов дресинг - 350 гр',
  'Салата хрупкаво пиле': 'Салата хрупкаво пиле',
  'Айсбег, домат, царевица, панирано пиле, чеснов сос, пармезан': 'Айсбег, домат, царевица, панирано пиле, чеснов сос, пармезан',
  'Шоколадова кариолка': 'Шоколадова кариолка',
  'Шоколад , масло , ядки - 70 гр. / бр': 'Шоколад , масло , ядки - 70 гр. / бр',
  'Крем Ден и нощ': 'Крем Ден и нощ',
  'масло, сметана, шоколад, пандишпан, ядки - 160 гр. / бр': 'масло, сметана, шоколад, пандишпан, ядки - 160 гр. / бр',
  'Кока кола – 330ml': 'Кока кола – 330ml',
  '': '',
  'Фанта Портокал – 330ml': 'Фанта Портокал – 330ml',
  'Спрайт – 330ml': 'Спрайт – 330ml',
  'Кока кола – 500мл': 'Кока кола – 500мл',
  'Фанта Портокал – 500мл': 'Фанта Портокал – 500мл',
  'Спрайт – 500мл': 'Спрайт – 500мл',
  'Фанта Лимон – 500мл': 'Фанта Лимон – 500мл',
  'Кока кола – 2L': 'Кока кола – 2L',
  'Фанта Портокал – 2L': 'Фанта Портокал – 2L',
  'Нестий праскова – 500ml': 'Нестий праскова – 500ml',
  'Нестий лимон – 500ml': 'Нестий лимон – 500ml',
  'Нестий горски плод – 500ml': 'Нестий горски плод – 500ml',
  'Нестий манго и ананас – 500ml': 'Нестий манго и ананас – 500ml',
  'Минерална вода – 500ml': 'Минерална вода – 500ml',
  'Минерална вода – 1,5L': 'Минерална вода – 1,5L',
  'Айран – 330ml': 'Айран – 330ml',
  'Загорка кен – 500ml': 'Загорка кен – 500ml',
  'Хайникен кен – 500ml': 'Хайникен кен – 500ml',
  'Хайнекен 330': 'Хайнекен 330',
  'Кетчуп': 'Кетчуп',
  '50 гр': '50 гр',
  'Майонеза': 'Майонеза',
  'Горчица': 'Горчица',
  'Чили сос': 'Чили сос',
  'Чеснов сос': 'Чеснов сос',
  'Барбекю': 'Барбекю',
  'Сладко чили': 'Сладко чили',
  'Цезар': 'Цезар',
  'Песто': 'Песто',
  'Ница сос': 'Ница сос'
  
  },
};

function mergeTranslationSets(base = {}, overrides = {}) {
  const merged = {};
  const languages = new Set([
    ...Object.keys(base || {}),
    ...Object.keys(overrides || {}),
  ]);

  languages.forEach((language) => {
    const baseEntries = base[language];
    const overrideEntries = overrides[language];
    const safeBase = baseEntries && typeof baseEntries === "object" && !Array.isArray(baseEntries)
      ? baseEntries
      : {};
    const safeOverrides = overrideEntries && typeof overrideEntries === "object" && !Array.isArray(overrideEntries)
      ? overrideEntries
      : {};

    merged[language] = { ...safeBase, ...safeOverrides };
  });

  return merged;
}

let translations = mergeTranslationSets(defaultTranslations);
let cachedVersion = 0;
let isInitialized = false;
let availableLanguages = Object.keys(defaultTranslations);

function normalizeLocale(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/_/g, "-");
}

function normalizeLanguages(value) {
  if (!Array.isArray(value)) {
    return [];
  }

  return Array.from(
    new Set(
      value
        .filter((entry) => typeof entry === "string")
        .map((entry) => normalizeLocale(entry).split("-")[0])
        .filter(Boolean)
    )
  );
}

function getLocaleCandidates(value) {
  const normalized = normalizeLocale(value);
  if (!normalized) return [];
  const base = normalized.split("-")[0];
  if (!base) return [];
  if (normalized === base) return [normalized];
  return [normalized, base];
}

function getDefaultLocale() {
  const configured = Config.defaultLanguage
    || Config.defaultLocale
    || process.env.EXPO_PUBLIC_DEFAULT_LOCALE
    || Localization.locale
    || ENV_FALLBACK_LOCALE
    || "en";
  return normalizeLocale(configured) || "en";
}

const FALLBACK_LOCALE = getDefaultLocale();
let locale = FALLBACK_LOCALE;

function resolveLanguage() {
  for (const candidate of getLocaleCandidates(locale)) {
    if (translations[candidate]) return translations[candidate];
  }

  for (const candidate of getLocaleCandidates(FALLBACK_LOCALE)) {
    if (translations[candidate]) return translations[candidate];
  }

  return translations.en || translations.bg || {};
}

async function initializeLocale() {
  try {
    const storedLocale = await AsyncStorage.getItem(LOCALE_KEY);
    if (storedLocale && storedLocale !== "auto") {
      locale = storedLocale;
    } else {
      locale = getDefaultLocale();
    }
  } catch (ex) {
    console.warn("[Localization] Failed to load locale:", ex);
    locale = getDefaultLocale();
  }
}

async function loadCachedTranslations() {
  try {
    const cached = await AsyncStorage.getItem(TRANSLATIONS_KEY);
    const version = await AsyncStorage.getItem(TRANSLATIONS_VERSION_KEY);
    const cachedLanguages = await AsyncStorage.getItem(TRANSLATIONS_LANGUAGES_KEY);

    if (cached) {
      const parsed = JSON.parse(cached);
      if (parsed && typeof parsed === "object") {
        translations = mergeTranslationSets(defaultTranslations, parsed);
      }
      cachedVersion = Number.parseInt(version || "0", 10) || 0;
    }

    if (cachedLanguages) {
      const parsedLanguages = normalizeLanguages(JSON.parse(cachedLanguages));
      if (parsedLanguages.length > 0) {
        availableLanguages = parsedLanguages;
      }
    } else {
      const fallbackLanguages = normalizeLanguages(Object.keys(translations));
      if (fallbackLanguages.length > 0) {
        availableLanguages = fallbackLanguages;
      }
    }
  } catch (ex) {
    console.warn("[Localization] Failed to load cached translations:", ex);
  }
}

async function fetchTranslations() {
  try {
    const response = await fetch(`${API_URL}/api/translations?version=${cachedVersion}`, {
      headers: {
        Accept: "application/json",
      },
    });

    if (response.status === 304) {
      return;
    }

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const data = await response.json();
    if (data?.translations && typeof data.translations === "object") {
      translations = mergeTranslationSets(translations, data.translations);
      cachedVersion = Number.parseInt(String(data.version || 0), 10) || 0;
      await AsyncStorage.setItem(TRANSLATIONS_KEY, JSON.stringify(data.translations));
      await AsyncStorage.setItem(TRANSLATIONS_VERSION_KEY, String(cachedVersion));

      const nextLanguages = normalizeLanguages(
        Array.isArray(data.languages) ? data.languages : Object.keys(data.translations)
      );
      if (nextLanguages.length > 0) {
        availableLanguages = nextLanguages;
        await AsyncStorage.setItem(TRANSLATIONS_LANGUAGES_KEY, JSON.stringify(nextLanguages));
      }
    }
  } catch (ex) {
    // Keep bundled and cached translations when remote is unavailable.
    console.warn("[Localization] Failed to fetch remote translations:", ex);
  }
}

function t(text) {
  if (!text) return "";
  const lang = resolveLanguage();
  return lang[text] !== undefined ? lang[text] : text;
}

async function setLocale(newLocale) {
  locale = newLocale === "auto" ? getDefaultLocale() : newLocale;
  try {
    await AsyncStorage.setItem(LOCALE_KEY, newLocale);
  } catch (ex) {
    console.warn("[Localization] Failed to persist locale:", ex);
  }
}

function getLocale() {
  return locale;
}

function getLanguages() {
  return availableLanguages;
}

async function refreshTranslations() {
  cachedVersion = 0;
  await fetchTranslations();
}

void (async () => {
  await initializeLocale();
  await loadCachedTranslations();
  await fetchTranslations();
  isInitialized = true;
})();

const localization = {
  t,
  setLocale,
  getLocale,
  getDefaultLocale,
  getLanguages,
  refreshTranslations,
  get isInitialized() {
    return isInitialized;
  },
  get locale() {
    return locale;
  },
  set locale(value) {
    // Keep compatibility with existing `i18n.locale = "xx"` call sites.
    void setLocale(value);
  },
};

export default localization;
